import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { Button } from "../../components/ui/button";
import { LayoutList, Radio, SlidersHorizontal, LogOut, Building2, KeyRound } from "lucide-react";

const links = [
  { to: "/admin", end: true, label: "Simulazioni", icon: LayoutList, testid: "nav-simulazioni" },
  { to: "/admin/canali", label: "Canali", icon: Radio, testid: "nav-canali" },
  { to: "/admin/parametri", label: "Parametri", icon: SlidersHorizontal, testid: "nav-parametri" },
  { to: "/admin/cambia-password", label: "Cambia password", icon: KeyRound, testid: "nav-cambia-password" },
];

export const AdminLayout = () => {
  const { logout } = useAuth();
  const nav = useNavigate();
  const doLogout = async () => { await logout(); nav("/admin/login"); };

  return (
    <div className="min-h-screen bg-[#F5F8F7]">
      <header className="bg-white border-b border-[#DDE5E2] sticky top-0 z-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 h-16 flex items-center justify-between">
          <div className="flex items-center gap-2 text-[#2B3A42]">
            <Building2 className="h-5 w-5 text-[#6C8EAD]" />
            <span className="font-display font-semibold">Studio Scala Milano</span>
            <span className="hidden sm:inline text-xs text-[#5B6E78] ml-2">Area riservata</span>
          </div>
          <Button variant="ghost" onClick={doLogout} data-testid="admin-logout-btn"
            className="text-[#5B6E78] hover:text-[#2B3A42] gap-2">
            <LogOut className="h-4 w-4" /> Esci
          </Button>
        </div>
        <nav className="max-w-7xl mx-auto px-4 sm:px-8 flex gap-1 overflow-x-auto">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end} data-testid={l.testid}
              className={({ isActive }) =>
                `flex items-center gap-2 px-4 py-3 text-sm font-medium border-b-2 whitespace-nowrap transition-colors ${
                  isActive ? "border-[#6C8EAD] text-[#2B3A42]" : "border-transparent text-[#5B6E78] hover:text-[#2B3A42]"
                }`}>
              <l.icon className="h-4 w-4" /> {l.label}
            </NavLink>
          ))}
        </nav>
      </header>
      <main className="max-w-7xl mx-auto px-4 sm:px-8 py-8">
        <Outlet />
      </main>
    </div>
  );
};
